import { BaseState } from '@/store/base-state';
import { Projects, DetailsFilters } from '@/modules/projects/types';
import { PaginationProps, TableOptions, Filters } from '@/types';

export default class ProjectDetailsState extends BaseState {
  products: Projects.Product[] = [];
  equipments: Projects.Equipments[] = [];
  competitors: Projects.Competitors[] = [];
  history: Projects.History[] = [];
  orders_realizations: Projects.OrdersRealizations[] = [];
  regions: Projects.Regions[] = [];
  products_loading = false;
  equipments_loading = false;
  competitors_loading = false;
  history_loading = false;
  realizations_loading = false;

  cart_is_empty = false;

  equipments_table_options: TableOptions = this.create_table_opts;
  equipments_pagination_props: PaginationProps = this.create_pagination_props;
  equipments_filters: Filters = {
    search: '',
  }

  competitors_table_options: TableOptions = this.create_table_opts;
  competitors_pagination_props: PaginationProps = this.create_pagination_props;
  competitors_filters: Filters = {
    search: '',
  }

  history_table_options: TableOptions = this.create_table_opts;
  history_pagination_props: PaginationProps = this.create_pagination_props;
  history_filters: Filters = {
    search: '',
  }

  realizations_table_options: TableOptions = this.create_table_opts;
  realizations_pagination_props: PaginationProps = this.create_pagination_props;
  realizations_filters: DetailsFilters = {
    search: '',
    document_type: false,
  };

  filters: DetailsFilters = {
    search: '',
    document_type: false,
  };
}
